import * as Yup from 'yup';

// ----------------------------------------------------------------------

export const NuvemshopFormSchema = Yup.object().shape({
  activatedGroup: Yup.array().of(Yup.string()),
});

export type TNuvemshopConfigFormSchema = Yup.InferType<typeof NuvemshopFormSchema>;

export const nuvemshopConfigFormSchemaDefaultValues: TNuvemshopConfigFormSchema = {
  activatedGroup: [],
};